"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var hideStyle = {
  display: 'none'
};
var Meta = function Meta(props, ref) {
  var _a, _b;
  var type = props.type,
    children = props.children,
    className = props.className,
    _c = props.notExpandClassName,
    notExpandClassName = _c === void 0 ? false : _c,
    ExpandComponent = props.ExpandComponent,
    // eslint-disable-line
    _d = props.showExpandComponent,
    // eslint-disable-line
    showExpandComponent = _d === void 0 ? true : _d,
    expandClassName = props.expandClassName,
    expandStyle = props.expandStyle,
    _e = props.alignment,
    alignment = _e === void 0 ? 'content' : _e,
    _f = props.direction,
    direction = _f === void 0 ? 'row' : _f,
    legacy = props.legacy,
    _g = props.hasLabel,
    hasLabel = _g === void 0 ? true : _g,
    labelPaddingLeft = props.labelPaddingLeft,
    labelPaddingY = props.labelPaddingY,
    labelWidth = props.labelWidth,
    labelWidthAuto = props.labelWidthAuto,
    innerStyle = props.innerStyle,
    innerClassName = props.innerClassName,
    innerAlignItems = props.innerAlignItems,
    htmlRef = props.htmlRef,
    id = props.id,
    style = props.style,
    _h = props.classNameMap,
    classNameMap = _h === void 0 ? {} : _h,
    _j = props.show,
    show = _j === void 0 ? true : _j,
    _k = props.required,
    required = _k === void 0 ? false : _k,
    restProps = __rest(props, ["type", "children", "className", "notExpandClassName", "ExpandComponent", "showExpandComponent", "expandClassName", "expandStyle", "alignment", "direction", "legacy", "hasLabel", "labelPaddingLeft", "labelPaddingY", "labelWidth", "labelWidthAuto", "innerStyle", "innerClassName", "innerAlignItems", "htmlRef", "id", "style", "classNameMap", "show", "required"]);
  var cssText = __assign((_a = {}, _a['--meta-inner-align'] = innerAlignItems, _a['--meta-name-py'] = typeof labelPaddingY === 'number' ? "".concat(labelPaddingY, "px") : labelPaddingY, _a['--meta-name-pl'] = typeof labelPaddingLeft === 'number' ? "".concat(labelPaddingLeft, "px") : labelPaddingLeft, _a['--meta-name-width'] = labelWidthAuto ? 'auto' : (0, spaui_utils_1.pxVal)(labelWidth), _a), style);
  return show ? react_1["default"].createElement("div", __assign({}, restProps, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])(classNameMap.Meta || 'meta', type ? "has-".concat(type) : '', {
      expanded: ExpandComponent,
      'is-column': direction === 'column',
      'meta-legacy': legacy,
      'no-label': !hasLabel,
      required: required
    }),
    supportAllEvents: true,
    ref: ref
  }, Meta), {
    style: (0, spaui_utils_1.removeUndefined)(cssText)
  }), react_1["default"].createElement("div", {
    className: (0, classnames_1["default"])(classNameMap.Inner || 'meta-inner', innerClassName),
    style: innerStyle
  }, children), ExpandComponent ? react_1["default"].createElement("div", {
    className: notExpandClassName ? '' : (0, classnames_1["default"])(classNameMap.Expand || 'meta-expand', expandClassName, (_b = {}, _b["align-".concat(alignment)] = alignment, _b)),
    style: showExpandComponent ? expandStyle : hideStyle
  }, ExpandComponent) : null) : null;
};
(0, spaui_utils_1.setComponentMark)(Meta, info_1["default"]);
exports["default"] = react_1["default"].memo((0, react_1.forwardRef)(Meta));